module.exports = {
  'en': {
    'HRES6NUC1': {
      '0': 'Cancle List of Leave Application',
      '10': '[HRES6NU] Cancle List of Leave Application',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Department',
      '60': 'Position',
      '70': 'Req. Date',
      '80': 'Seq No.',
      '90': 'Leave Code',
      '100': 'Leave Cancle Date',
      '110': 'Status',
      '120': 'Approved By',
      '130': 'Appr.Date',
      '140': 'Remark',
      '150': 'Next Approve',
      '160': 'Leave Date'
    },
    'HRES6NUC2': {
      '0': 'Details of Approve',
      '10': 'Details of Approve',
      '20': 'For Employee',
      '30': 'Seq. No',
      '40': 'Approved By',
      '50': 'Approved Date',
      '60': 'Current Status',
      '70': 'Status',
      '80': 'Approved',
      '90': 'Refused',
      '100': 'Remark',
      '110': 'No.of selected',
      '120': 'Record'
    },
    'HRES6NUC3': {
      '0': 'Detail of Cancle Leave',
      '10': 'Detail of Cancle Leave',
      '20': 'Leave Code',
      '30': 'Description',
      '40': 'From Date',
      '50': 'Time',
      '60': 'To Date',
      '70': 'Time',
      '80': 'Leave Entitlement',
      '90': 'History of Leave',
      '100': 'Employee name',
      '110': 'Request date'
    }
  },
  'th': {
    'HRES6NUC1': {
      '0': 'อนุมัติยกเลิกการลาหยุดงาน',
      '10': '[HRES6NU] อนุมัติยกเลิกการลาหยุดงาน',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'หน่วยงาน',
      '60': 'ตำแหน่ง',
      '70': 'วันที่ขอ',
      '80': 'ลำดับที่',
      '90': 'รหัสการลา',
      '100': 'ช่วงวันที่ขอยกเลิกลาหยุดงาน',
      '110': 'สถานะ',
      '120': 'ผู้อนุมัติ',
      '130': 'วันที่อนุมัติ',
      '140': 'หมายเหตุการอนุมัติ',
      '150': 'ผู้อนุมัติลำดับถัดไป',
      '160': 'วันที่ขอลา'
    },
    'HRES6NUC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'รายละเอียดการอนุมัติ',
      '20': 'สำหรับพนักงาน',
      '30': 'ลำดับที่อนุมัติ',
      '40': 'อนุมัติโดย',
      '50': 'วันที่อนุมัติ',
      '60': 'สถานะปัจจุบัน',
      '70': 'สถานะ',
      '80': 'อนุมัติ',
      '90': 'ไม่อนุมัติ',
      '100': 'หมายเหตุ',
      '110': 'รายการที่เลือกทั้งหมด',
      '120': 'รายการ'
    },
    'HRES6NUC3': {
      '0': 'รายละเอียดขอยกเลิกการลาหยุดงาน',
      '10': 'รายละเอียดขอยกเลิกการลาหยุดงาน',
      '20': 'รหัสการลา',
      '30': 'รายละเอียด',
      '40': 'ตั้งแต่วันที่',
      '50': 'เริ่มเวลา',
      '60': 'ถึงวันที่',
      '70': 'ถึงเวลา',
      '80': 'สิทธิการลาหยุดงาน',
      '90': 'ประวัติการลา',
      '100': 'รหัสพนักงาน',
      '110': 'วันที่ขอ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6nu.js